
export const COMMON_PATH = {
  LOGIN: '/',
  ENTRANCE: '/entrance'
};
